import React, { useState } from "react";

import logo from "../assets/img/logo.svg";

import { useAuth } from "../hooks";

const initialState = {
  email: "",
  password: "",
};

export function LoginForm({
  handleChangeToRecoverPassword,
}) {
  const [data, setData] = useState(initialState);
  const [signInError, setSignInError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const { logIn } = useAuth();

  const handleOnChange = ({ name, value }) => {
    setData({
      ...data,
      [name]: value,
    });

    if (signInError) {
      setSignInError("");
    }
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    logIn(data).catch(() => {
      setSignInError(
        "Correo o contraseña incorrectos."
      );
    });
  };

  return (
    <div className="ps-login-card">

      <div className="ps-login-logo">
        <img
          src={logo}
          alt="PS Proceso Seguro"
        />
      </div>

      <div className="ps-login-heading">
        <h1>Iniciar sesión</h1>
        <p>Plataforma de capacitación</p>
      </div>

      <form
        className="ps-login-form"
        onSubmit={handleOnSubmit}
      >

        <div className="ps-login-field">
          <label htmlFor="email">
            Correo electrónico
          </label>

          <div className="ps-login-input">
            <i className="far fa-envelope" />

            <input
              id="email"
              name="email"
              type="email"
              required
              autoComplete="email"
              value={data.email}
              placeholder="Correo electrónico"
              onChange={({ target }) =>
                handleOnChange(target)
              }
            />
          </div>
        </div>

        <div className="ps-login-field">
          <div className="ps-login-label-row">
            <label htmlFor="password">
              Contraseña
            </label>

            <button
              type="button"
              className="ps-login-link"
              onClick={
                handleChangeToRecoverPassword
              }
            >
              ¿Olvidaste tu contraseña?
            </button>
          </div>

          <div className="ps-login-input">
            <i className="fas fa-lock" />

            <input
              id="password"
              name="password"
              type={
                showPassword
                  ? "text"
                  : "password"
              }
              required
              autoComplete="current-password"
              value={data.password}
              placeholder="Contraseña"
              onChange={({ target }) =>
                handleOnChange(target)
              }
            />

            <button
              type="button"
              className="ps-login-eye"
              title={
                showPassword
                  ? "Ocultar contraseña"
                  : "Mostrar contraseña"
              }
              onClick={() =>
                setShowPassword((old) => !old)
              }
            >
              <i
                className={
                  showPassword
                    ? "far fa-eye-slash"
                    : "far fa-eye"
                }
              />
            </button>
          </div>
        </div>

        {signInError && (
          <div className="ps-login-error">
            {signInError}
          </div>
        )}

        <button
          type="submit"
          className="ps-login-submit"
        >
          Ingresar
        </button>

      </form>

      <div className="ps-login-footer">
        PS Proceso Seguro
      </div>

    </div>
  );
}
